<template>
  <section>
    <h2>Boutique</h2>
    <div
      class="d-flex align-items-center justify-sm-content-around my-4 row no-gutters"
    >
      <!-- <div
                class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-2 my-sm-0 mx-1">
                <button style="background: url(../../assets/Logo Kisdis/Objet dynamique vectoriel4-01.png)" @click="modalE_Learning = !modalE_Learning" type="button"
                    class="btn btn_boutique ">
                </button>
                <span class="text-success span_repertoire">E-Learning</span>
      </div>-->
      <div
        class="col-3 col-sm-2 order-1 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <!-- <button @click="modalE_Learning = !modalE_Learning" type="button"
                    class="btn btn-primary btn_boutique " disabled>
                    <font-awesome-icon icon="video" size="2x" />
        </button>-->
        <a href="#">
          <img
            class="btn_boutique rounded"
            src="../../assets/Logo Kisdis/Objet dynamique vectoriel4-01.png"
            alt
          />
        </a>
        <span class="text-success span_repertoire">Kis Coach</span>
      </div>

      <div
        class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <button type="button" class="btn btn-primary btn_boutique">
          <font-awesome-icon icon="video" size="2x" />
        </button>
        <span class="text-primary span_repertoire">Kis Legal</span>
      </div>

      <div
        class="col-3 col-sm-2 order-3 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <a href="#">
          <img
            class="btn_boutique rounded"
            src="../../assets/Logo Kisdis/Objet dynamique vectoriel4-03.png"
            alt
          />
        </a>
        <span class="text-primary span_repertoire">Kis Relax</span>
      </div>

      <div
        class="col-3 col-sm-2 order-4 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <a href="#">
          <img
            class="btn_boutique rounded"
            src="../../assets/Logo Kisdis/Objet dynamique vectoriel4-05.png"
            alt
          />
        </a>
        <span class="text-primary span_repertoire">Kis Office</span>
      </div>

      <div
        class="col-3 col-sm-2 order-5 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <a href="#">
          <img
            class="btn_boutique rounded"
            src="../../assets/Logo Kisdis/Objet dynamique vectoriel4-04.png"
            alt
          />
        </a>
        <span class="text-danger span_repertoire">Kis Sport</span>
      </div>

      <div
        class="col-3 col-sm-2 order-6 d-flex flex-column justify-content-around align-items-center my-2 mb-sm-3"
      >
        <a href="#">
          <img
            class="btn_boutique rounded"
            src="../../assets/Logo Kisdis/Objet dynamique vectoriel4-06.png"
            alt
          />
        </a>
        <span class="text-primary span_repertoire">Kis Safety</span>
      </div>
      <!-- <div
                class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-2 my-sm-0 mx-1">
                <button @click="modalE_Learning = !modalE_Learning" type="button"
                    class="btn btn-success btn_boutique " disabled>
                    <font-awesome-icon icon="video" size="2x" />
                </button>
                <span class="text-success span_repertoire">Kis Coach</span>

                <b-modal v-model="modalE_Learning" size="xl" centered ok-only scrollable title="E-Learning">
                    <div role="group">
                        <label for="inputLearning">Quel est votre demande ?</label>
                        <b-form-input id="inputLearning" v-model="name" trim type="text" :state="nameState"
                            aria-describedby=" inputLiveFeedback" placeholder="Entrer votre demande" />

                        This will only be shown if the preceeding input has an invalid state
                        <b-form-invalid-feedback id="inputLiveFeedback">
                            Entrer le mot "apprendre"
                        </b-form-invalid-feedback>

                        This is a form text block (formerly known as help block)

                    </div>
                </b-modal>
            </div>

            <div
                class="col-3 col-sm-2 order-3 d-flex flex-column justify-content-around align-items-center my-2 my-sm-0 mx-1">
                <button @click="modalSport = !modalSport" type="button" class="btn btn-dark btn_boutique">
                    <font-awesome-icon icon="swimmer" size="2x" />

                </button>
                <span class="text-dark span_repertoire">Sport</span>
                <b-modal v-model="modalSport" size="xl" centered ok-only scrollable title="Sport" @ok="handleOkSport">
                    <b-form-select v-model="selectedSport" :options="options" />
                </b-modal>
                a
                <b-modal v-model="modalSportA" size="xl" centered ok-only scrollable title="Pompes"><img
                        src="../../assets/Sport/Les-pompes.gif" class="img-fluid" alt="Responsive image">
                </b-modal>
                b
                <b-modal v-model="modalSportB" size="xl" centered ok-only scrollable title="Pointeur"><img
                        src="../../assets/Sport/Le-pointeur.gif" class="img-fluid" alt="Responsive image">
                </b-modal>
            </div>


            <div
                class="col-3 col-sm-2 order-5 d-flex flex-column justify-content-around align-items-center my-2 my-sm-0 mx-1">
                <button @click="modalNo_limit = !modalNo_limit" type="button" class="btn btn-primary btn_boutique ">
                    <font-awesome-icon icon="infinity" size="2x" />
                </button>
                <span class="text-primary span_repertoire">No limit</span>

                <b-modal v-model="modalNo_limit" title="No limit" :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant" :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant" :footer-bg-variant="footerBgVariant"
                    :footer-text-variant="footerTextVariant" centered>
                    <b-container fluid>
                        <b-row class="mb-1 text-center">
                            <b-col cols="3" />
                            <b-col>Background</b-col>
                            <b-col>Text</b-col>
                        </b-row>

                        <b-row class="mb-1">
                            <b-col cols="3">Header</b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="headerBgVariant" />
                            </b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="headerTextVariant" />
                            </b-col>
                        </b-row>

                        <b-row class="mb-1">
                            <b-col cols="3">Body</b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="bodyBgVariant" />
                            </b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="bodyTextVariant" />
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="3">Footer</b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="footerBgVariant" />
                            </b-col>
                            <b-col>
                                <b-form-select :options="variants" v-model="footerTextVariant" />
                            </b-col>
                        </b-row>
                    </b-container>

                    <div slot="modal-footer" class="w-100">
                        <p class="float-left">Footer Content</p>
                        <b-button size="sm" class="float-right" variant="primary" @click="modalNo_limit=false">Fermer
                        </b-button>
                    </div>
                </b-modal>

      </div>-->
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    nameState() {
      return !this.name.search("apprendre") ? true : false;
    }
  },
  data() {
    return {
      name: " ",
      modalE_Learning: false,
      modalInformation: false,
      modalInformationDocument1: false,
      modalInformationDocument2: false,
      modalInformationDocument3: false,
      ModalTestApple: false,
      modalSport: false,
      modalNo_limit: false,
      variants: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "light",
        "dark"
      ],
      headerBgVariant: "dark",
      headerTextVariant: "light",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
      selectedSport: null,
      options: [
        {
          value: null,
          text: "Merci de faire votre choix"
        },
        {
          value: "a",
          text: "Les bras et les épaules"
        },
        {
          value: "b",
          text: "Les muscles du dos"
        }
      ],
      modalSportA: false,
      modalSportB: false
    };
  },

  methods: {
    // handleOkSport(evt) {
    //     switch (this.selectedSport) {
    //         case 'a':
    //             console.log("a")
    //             this.modalSportA = true
    //             break;
    //         case 'b':
    //             console.log("b")
    //             this.modalSportB = true
    //             break;
    //         default:
    //             console.log("ko")
    //     }
    //     this.selectedSport = null
    // }
  }
};
</script>

<style scoped>
.btn_boutique {
  width: 4.5rem;
  height: 4.5rem;
  /* Centrer et aligner image dans button */
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}
</style>
